import { getParsedCookie } from '../util/cookies'

import { CookieCategoryTypes } from './types'

const activeCookieCategories = (): CookieCategoryTypes[] => {
  const cookieContent = getParsedCookie('OptanonConsent')

  if (!cookieContent) {
    return [] as CookieCategoryTypes[]
  }

  const consentCategoryGroups = cookieContent.get('groups')

  if (!consentCategoryGroups) {
    return [] as CookieCategoryTypes[]
  }

  const activeGroups = consentCategoryGroups.match(/([A-Z]\d+):1/g)

  return (activeGroups ? activeGroups.map(match => match.split(':')[0]) : []) as CookieCategoryTypes[]
}

export const isCookieCategoryEnabled = (type: CookieCategoryTypes) => {
  return activeCookieCategories().includes(type)
}
